import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

const getInitials = (name) => {
    const parts = String(name || '').trim().split(/\s+/).filter(Boolean);
    if (!parts.length) return '?';
    const first = parts[0][0];
    const last = parts.length > 1 ? parts[parts.length - 1][0] : '';
    return `${first}${last}`.toUpperCase();
};

// Renders the avatar image, falling back to the person's initials when there
// is no image or it fails to load (e.g. a stale storage URL).
const Avatar = ({ src, name, className, fallbackClassName }) => {
    const [failed, setFailed] = useState(false);

    useEffect(() => { setFailed(false); }, [src]);

    if (!src || failed) {
        return (
            <span className={`avatar-fallback ${fallbackClassName}`.trim()} aria-label={name || 'avatar'} role="img">
                {getInitials(name)}
            </span>
        );
    }

    return <img className={className} src={src} alt={name || 'avatar'} onError={() => setFailed(true)} />;
};

Avatar.propTypes = {
    src: PropTypes.string,
    name: PropTypes.string,
    className: PropTypes.string,
    fallbackClassName: PropTypes.string,
};

Avatar.defaultProps = {
    src: '',
    name: '',
    className: undefined,
    fallbackClassName: '',
};

export default Avatar;
